export default __webpack_public_path__ + "static/media/flag-senegal.7ef5452a.svg";